module.exports = __webpack_public_path__ + "static/media/piper-settings-audience.d79eb95c.svg";